import {createAction} from '@reduxjs/toolkit';

import {UserDetail} from 'types';

// import {ISession} from 'types/session';

export const setAuthTokensAction = createAction<any>('SET_AUTH_TOKENS');

export const setIsTokenExpiredAction = createAction<boolean>('SET_IS_TOKEN_EXPIRED');

export const fetchUserDetailsAction = createAction('FETCH_USER_DETAILS');

export const setUserDetailsAction = createAction<UserDetail>('SET_USER_DETAILS');
